import { OFACScreeningStatusEnum } from 'anchor-kyb-service/types';
export class LatestOFACSanctionStatusModel {
  constructor(dto) {
    this.dto = dto;
  }
  requiresInquiry() {
    return !this.dto.status || ![OFACScreeningStatusEnum.Cleared, OFACScreeningStatusEnum.AwaitingDecision].includes(this.dto.status);
  }
}